import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import TemplateWrapper2 from '../components/Layout2'
import Feature2 from '../components/Feature2'
import SocialNetworks from '../components/SocialNetworks'
import { graphql, navigate } from 'gatsby';
import { getImage } from '../utils';
import { Helmet } from 'react-helmet';
import Truncate from 'react-truncate';
import showdown from 'showdown';
import ProjectsGallery from '../components/ProjectsGallery'
import TestimonialsRoll from '../components/TestimonialsRoll'

const converter = new showdown.Converter();

export const ProjectsPageTemplate = ({
    isPreview = false
}) => {
    return (
        <div
            id="list"
            className="container-fluid px-0">
            {
                !isPreview && (
                    <div className="container container-max pt-5">
                        <ProjectsGallery />
                    </div>
                )
            }
            {
                isPreview && (
                    <div className="container container-max pt-5">
                        <TestimonialsRoll />
                    </div>
                )
            }
        </div>
    )
}

const ProjectsPage = ({
    location,
}) => {
    return (
        <TemplateWrapper2
            location={location}>
            <>
                <Helmet titleTemplate="%s">
                    <title>
                        Casas y condominios campestres- Constructora Berdez
                    </title>
                    <meta
                        name="description"
                        content="Conoce los nuevos proyectos de vivienda que se encuentran en Neiva, Huila."
                    />
                </Helmet>
                <ProjectsPageTemplate
                />
            </>
        </TemplateWrapper2>
    )
}

export default ProjectsPage;